import { render, staticRenderFns } from "./SchoolClasses.vue?vue&type=template&id=04a79ea8"
import script from "./SchoolClasses.vue?vue&type=script&lang=js"
export * from "./SchoolClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports